<template>
  <div
    class="w-full max-w-xl px-5 py-2 mt-2 mb-4 rounded-2xl text-center mx-auto flex justify-between"
  >
    <div>
      <p class="font-semibold text-18">Costo Mensual:</p>
    </div>
    <div class="text-right">
      <p class="font-bold text-18">{{ monthlyCost }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  product: {
    type: Object,
    default: null
  },
  paymentMethod: {
    type: String,
    default: ''
  },
  effectivoPrice: {
    type: Object,
    default: null
  },
  flagHD: {
    type: Boolean,
    default: false
  },
  precioHD: {
    type: Number,
    default: 20
  }
});

const monthlyCost = computed(() => {
  if (!props.product?.precio) return 'Cargando...';

  const basePrice = parseFloat(props.product.precio);
  const hdPrice = props.flagHD ? props.precioHD : 0;

  if (props.paymentMethod === 'paypal') {
    return `$${(basePrice + hdPrice).toFixed(2)}`;
  }

  if (props.paymentMethod === 'efectivo' && props.effectivoPrice?.monto) {
    const efectivoBase = parseFloat(props.effectivoPrice.monto);
    return `$${(efectivoBase + hdPrice).toFixed(2)}`;
  }

  if (props.paymentMethod === 'card' || props.paymentMethod === 'telmex') {
    return `$${basePrice.toFixed(2)}`;
  }

  return `$${basePrice.toFixed(2)}`;
});
</script>
